import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { Checkbox, Grid, Typography } from "@material-ui/core";
import { IconLabelSwitch } from "../data-source/IconLabelSwitch";

/**
 * @author André K
 * 05/01/2023
 */

const useStyles = makeStyles((theme) => ({
    fillContainer: {
        minWidth: "100%",
    },
    center: {
        alignSelf: "center",
    },
    icon: {
        paddingTop: "5px",
    }
}));

const DefaultCheckBoxSelect = ({ onChange, error, list, spacing, name }) => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <FormControl
            variant="outlined"
            className={classes.fillContainer}
            size="small"
            error={error}
        >   <div>
                <IconLabelSwitch name={t(name)} />
            </div>
            <Grid container spacing={3}>
                {list.map((item) => {
                    return (
                        <Grid item xs={12} sm={3} md={3} spacing={35}>
                            <FormControlLabel
                                control={
                                    <Checkbox                                         
                                        checked={item.value}
                                        onChange={(e) => onChange({ target: { value: e.target.checked, name: item.name } })}
                                        color="primary"
                                        name={item.name}
                                        inputProps={{
                                            "aria-label": "primary checkbox",
                                        }}
                                        value={item.value}
                                        disabled={item.disabled}
                                    />
                                }
                                label={item.icon ? <IconLabelSwitch name={item.icon} /> : item.text ? <IconLabelSwitch labelName={t(item.text)} /> : <IconLabelSwitch labelName={t(item.name)} />}
                            />
                        </Grid>
                    )
                })}
            </Grid>
        </FormControl>
    );
};

export default DefaultCheckBoxSelect;
